import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import axios from 'axios';

const API_BASE = "https://atblogin.cubixsystems.com/myapp/api/uploads";
// const API_BASE = "https://spst.in/myapp/api/uploads";

// const API_BASE = "https://e-zone.in/myapp/api/uploads";

function NewsDetails() {
  const [uploads, setUploads] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    const res = await axios.get(`${API_BASE}/get_notice.php`);
    setUploads(res.data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this record?")) return;
    await axios.post(`${API_BASE}/delete_notice.php`, { id });
    fetchUploads();
  };

  const startEdit = (item) => {
    setEditId(item.id);
    setEditName(item.name);
  };

  const saveEdit = async () => {
    await axios.post(`${API_BASE}/update_notice.php`, { id: editId, name: editName });
    setEditId(null);
    fetchUploads();
  };

  return (
    <div style={{padding:'25px',borderRadius:'10px'}}>
      
      <table className="table">
        <thead>
          <tr>
            <th>#</th>
            {/* <th style={{color:'black'}}>ID</th> */}
            <th>News / Event Title</th>
            <th>File</th>
            <th>Uploaded</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {uploads.map((upload, index) => (
            <tr key={upload.id}>
              <td style={{color:'black'}}>{index + 1}</td> 
              {/* <td style={{color:'black'}}>{upload.id}</td> */}
              <td style={{color:'black'}}>
                {editId === upload.id ? (
                  <textarea className="form-control" style={{height:'200px'}}
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                  ></textarea>
                ) : (
                  upload.name
                )}
              </td>
              <td>
                {/* <Router>
                <Link to={`myapp/${upload.file_path}`} >
                  {upload.file_path}
                </Link>
                </Router> */}

                
                <a href={`../myapp/${upload.file_path}`} >
                  {upload.file_path}
                </a>
                
                
              </td>
              <td style={{color:'black'}}>{upload.uploaded_at}</td>
              <td>
                {editId === upload.id ? (
                  <>
                     <div class="row">
                        <div className="col-md-6">
                            <button onClick={saveEdit} class="btn btn-primary" style={{background:'green'}}>
                               <i class="fa fa-floppy-o" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div className="col-md-6">
                            <button onClick={() => setEditId(null)} class="btn btn-primary" style={{background:'gray'}}>
                               <i class="fa fa-window-close" aria-hidden="true"></i>
                            </button>
                        </div>
                     </div>
                    
                    
                  </>
                ) : (
                  <>
                  <div class="row">
                    <div className="col-md-6">
                      <button onClick={() => startEdit(upload)} class="btn btn-primary" style={{float:'left'}}>
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                    </div>
                    <div className="col-md-6">
                        <button onClick={() => handleDelete(upload.id)} class="btn btn-danger" style={{float:'left'}}>
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                    </div>

                  </div>
                    
                    
                  </>
                )}
              </td>
            </tr>
          ))}
          {uploads.length === 0 && (
            <tr>
              <td colSpan="5">No records found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default NewsDetails;
